// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_ResultFrame.scss
// module id = 529
// module chunks = 1 2 4 5 6 7 8 12 15 16 17 19 88